export default {
  title: 'What\'s new in Qmulus',
  titleWithVersion: 'What\'s new in release {version}',
  doNotShowAfterUpdates: 'Don\'t show for future updates',
  showAllReleases: 'Show all release highlights',
};
